/*
 * @Author: chenxuelai 2251702447@qq.com
 * @Date: 2023-08-02 18:14:49
 * @LastEditors: chenxuelai 2251702447@qq.com
 * @LastEditTime: 2023-08-03 11:52:41
 * @FilePath: /vue_huaqiang/src/utils/oms-download.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios, {AxiosRequestConfig, AxiosResponse} from "axios";
import {Message} from "element-ui";
import {UserModule} from "@/store/modules/user";

const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API + "/hq-oms", // url = base url + request url
    timeout: 120000
});

// Request interceptors
service.interceptors.request.use(
    (config: AxiosRequestConfig) => {
        if (UserModule.token && config && config.headers) {
            config.headers["X-Access-Token"] = UserModule.token
            config.headers["Authorization"] = UserModule.token
        }
        return config;
    },
    (error: ErrorEvent) => {
        Promise.reject(error);
    }
);

// Response interceptors
// service.interceptors.response.use(
//     (response: AxiosResponse) => {
//         const data: any = response.data;
//         const url = window.URL.createObjectURL(new Blob([data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}));
//         const link = document.createElement('a');
//         link.style.display = 'none';
//         const contentDisposition = response.headers["content-disposition"];
//         const strings = contentDisposition ? contentDisposition.split("filename=") : [];
//         link.href = url;
//         link.setAttribute('download', strings.length ? decodeURIComponent(decodeURI(strings[1])):decodeURI( '文件'));
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//         window.URL.revokeObjectURL(url);
//         return response.data || response
//     },
//     (error: any) => {
//         if (error.error.response.data.includes('4000')) {
//             const content = error.response.data;//arraybuffer类型数据
//             const resBlob = new Blob([content])
//             const reader = new FileReader()
//             reader.readAsText(resBlob, "utf-8")
//             reader.onload = () => {
//                 const res = JSON.parse(reader.result as any)
//                 console.log(res)
//                 Message({
//                     message: error.response.data.message || error.response.data,
//                     type: "error",
//                     duration: 5 * 1000
//                 });
//             }
//         } else {
//             Message({
//                 message: error.response.data.message || error.response.data,
//                 type: "error",
//                 duration: 5 * 1000
//             });
//         }
//         return Promise.reject(error);
//     }
// );
service.interceptors.response.use(
    (response) => {
        // 正常文件下载逻辑
        const data: any = response.data;
        const url = window.URL.createObjectURL(new Blob([data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}));
        const link = document.createElement('a');
        link.style.display = 'none';
        const contentDisposition = response.headers["content-disposition"];
        const strings = contentDisposition ? contentDisposition.split("filename=") : [];
        link.href = url;
        link.setAttribute('download', strings.length ? decodeURIComponent(decodeURI(strings[1])):decodeURI( '文件'));
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        return response.data || response
    },
    (error) => {
        // 处理错误响应（4000 或其他错误）
        if (error.response?.data instanceof Blob) {
            // 如果错误信息是 Blob（由于 responseType: "blob"）
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => {
                    try {
                        const errData = JSON.parse(reader.result as string);
                        if (errData.code === 4000) {
                            Message.error(errData.message); // 显示后端错误信息
                        } else {
                            Message.error("导出失败：" + errData.message);
                        }
                        reject(errData); // 继续抛出错误
                    } catch (e) {
                        Message.error("导出失败，数据解析错误");
                        reject(error);
                    }
                };
                reader.readAsText(error.response.data);
            });
        } else {
            // 普通错误（非 Blob）
            Message.error(error.message || "网络错误");
            return Promise.reject(error);
        }
    }
);

export default service;
